import { BaseXHR } from './axios';

export const getDetailPost = id => BaseXHR.$get('/post/getPublish', { id });
